export default {
  shippingLabel: {
    id: 'advertised_payment_shipping_label',
    defaultMessage: 'Free standard shipping on all orders.',
  },
}
